import {Options, TableColumn} from '@fl/cmsch-fe-library';

import {PermissionDetail} from 'api/gen/PermissionDetail';

/**
 * Builds the admin permissions table columns.
 *
 * @param discriminatorOptions Available discriminator options for the table filter.
 * @returns Table columns for the permissions table.
 */
// eslint-disable-next-line max-lines-per-function
export const permissionsColumns = (discriminatorOptions: Options<number>): Array<TableColumn<PermissionDetail>> => [
    {
        field: 'actionName',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString'],
    },
    {
        field: 'comment',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString', 'null'],
    },
    {
        field: 'code',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString', 'null'],
    },
    {
        field: 'controllerName',
        type: 'string',
        customFiltersOnly: true,
        filterTypes: ['containsString'],
    },
    {
        field: 'discriminatorId',
        type: 'option',
        options: discriminatorOptions,
        filterTypes: ['multiSelectNumber'],
        customFiltersOnly: true,
    },
    {
        field: 'userEnable',
        type: 'boolean',
    },
];
